import { createAppSlice } from "../../../store/createAppSlice";

export type ColorThemePreference = "system" | "light" | "dark";

export interface PreferencesState {
  sidebarWidth?: number;
  editorWidth?: number;
  executionLogsHeight?: number;
  isNavigationVisible: boolean;
  isPlaygroundSidebarVisible: boolean;
  isBrowsingHistory: boolean;
  colorTheme: ColorThemePreference;
}

const initialState: PreferencesState = {
  sidebarWidth: undefined,
  editorWidth: undefined,
  executionLogsHeight: undefined,
  isNavigationVisible: true,
  isPlaygroundSidebarVisible: false,
  isBrowsingHistory: false,
  colorTheme: "system",
};

const preferencesSlice = createAppSlice({
  name: "preferences",
  initialState,
  reducers: (create) => ({
    updatePreferences: create.reducer<Partial<PreferencesState>>((state, action) => {
      return { ...state, ...action.payload };
    }),
  }),
  selectors: {
    getPreferences: (state) => state,
  },
});

const { actions, selectors } = preferencesSlice;

export { actions, selectors, preferencesSlice };
